import script from "./FRemovePatient.vue?vue&type=script&setup=true&lang=ts"
export * from "./FRemovePatient.vue?vue&type=script&setup=true&lang=ts"

import "./FRemovePatient.vue?vue&type=style&index=0&id=56777214&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56777214"]])

export default __exports__